export default "__VITE_ASSET__DcRtW5gy__"